// extracted by mini-css-extract-plugin
export default {"title_wrapper":"NoticeDetail_title_wrapper__SISa+","notice_title":"NoticeDetail_notice_title__v9+nT","title":"NoticeDetail_title__o8kKk","textarea":"NoticeDetail_textarea__3kmuu"};